<template>
  <div class="w-full max-w-xl mx-auto p-5 flex justify-between" v-if="product">
    <div>
      <p class="font-semibold text-18">Gastos de Instalación</p>
    </div>
    <div class="text-right">
      <p class="text-blue text-18 font-semibold">
        Pago único de ${{ installationCost }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  product: {
    type: Object,
    default: null
  },
  paymentMethod: {
    type: String,
    default: ''
  },
  suscEfectivo: {
    type: [Number, String],
    default: 0
  }
});

const installationCost = computed(() => {
  if (props.paymentMethod === 'efectivo' || props.paymentMethod === 'paypal') {
    return parseFloat(props.suscEfectivo || 0).toFixed(2);
  }
  return parseFloat(props.product?.suscripcion || 0).toFixed(2);
});
</script>
